export default "__VITE_ASSET__09b9cd48__"